<template>
    <v-app id="app">

        <!-- Main content -->
        <v-main>
            <router-view/>
        </v-main>

        <v-snackbar color="error" top :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMessage || 'Something went wrong' | t }}</div>
            </div>
        </v-snackbar>

    </v-app>
</template>
<script>

import { mapActions, mapState, mapMutations } from "vuex";

export default {
    watch: {
        requestError(newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.setRequestError(false)
                }, 2500)
            }
        }
    },
    async mounted() {
        const token = this.$route.params.token;
        if (token) {
            await this.fetchData(token).then(success => {
                if (!success) {
                    this.$router.push({ name: 'error-view' });
                }
            });
        } else {
            this.$router.push({ name: 'error-view' });
        }
    },
    methods: {
        ...mapActions('PublicShipmentStore', ['fetchData']),
        ...mapMutations('PublicShipmentStore', ['setRequestError'])
    },
    computed: {
        ...mapState('PublicShipmentStore', ['requestError', 'errorMessage'])
    }
};
</script>

<style scoped>
</style>
